// Apolo IDE — SquadStatusChip (Squad Orchestrator E5).
//
// Chip do status 4-valorado de um operário (DONE / DONE_WITH_CONCERNS /
// NEEDS_CONTEXT / BLOCKED). Identidade vem de ÍCONE + LABEL, nunca só cor
// (doctrine); cores de --apolo-* tokens. Hover/estado neutros (lição
// prefers-contrast do Pedro: cor só no ícone/label).

import { Check, AlertTriangle, HelpCircle, X } from 'lucide-react';

const META = {
  DONE: { label: 'entregou', tone: 'text-apolo-success', Icon: Check },
  DONE_WITH_CONCERNS: { label: 'parcial', tone: 'text-apolo-warning', Icon: AlertTriangle },
  NEEDS_CONTEXT: { label: 'faltou contexto', tone: 'text-apolo-info', Icon: HelpCircle },
  BLOCKED: { label: 'bloqueado', tone: 'text-apolo-error', Icon: X },
};

export default function SquadStatusChip({ status }) {
  const meta = META[status];
  if (!meta) return null;
  const { label, tone, Icon } = meta;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-apolo-surface2 px-1.5 py-0.5 text-[10px] ${tone}`}
      title={`Operário: ${label}`}
    >
      <Icon size={10} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
